import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Button, Input, message, Typography, Divider} from 'antd';
import {changePasswordUrl} from "../stores/APIEndpoints";
import {isValidPassword} from "../stores/Util";

const {Password} = Input;
const {Text, Title} = Typography;

@inject("appStore")
@observer
export default class ChangePasswordForm extends Component {
    state = {
        password: null,
        passwordConfirmation: null,
        isValidPassword: false,
        loading: false,
    };

    onSubmit = async () => {
        this.setState({loading: true});

        const {appStore} = this.props;
        const {apiProxy} = appStore;

        const params = {
            user_email: appStore.credentials.email,
            token: appStore.credentials.token,
            password: this.state.password,
        };

        const response = await apiProxy.asyncPatch(changePasswordUrl, params);
        if (response.status == 200) {
            this.props.onRequestClose && this.props.onRequestClose();
            message.success('Password changed');
            this.setState({
                password: null,
                passwordConfirmation: null,
                isValidPassword: false,
                loading: false,
            });
        } else {
            message.error('Couldn\'t change the password');
        }

        this.setState({loading: false});
    };

    render() {
        return (
            <div style={styles.container}>
                <Title>Change Password</Title>
                <Text>Password should have</Text><br/>
                <Text>At least 8 characters</Text><br/>
                <Text>At least one special character</Text><br/>
                <Text>At least one upper case character</Text><br/>
                <Text>At least one lower case character</Text><br/>
                <Text>At least one number</Text>
                <Password
                    placeholder="Enter new password"
                    onChange={this.onChangePassword}
                    value={this.state.password}
                    style={styles.textField}
                />
                <br/>
                <Password
                    placeholder="Enter again"
                    onChange={this.onChangePasswordConfirmation}
                    value={this.state.passwordConfirmation}
                    style={styles.textField}
                />
                <Divider/>
                <div style={styles.buttonsContainer}>
                    <Button
                        onClick={this.onRequestClose}
                        style={styles.buttonCancel}
                    >Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={this.onSubmit}
                        disabled={!this.state.isValidPassword}
                        loading={this.state.loading}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        );
    }

    onRequestClose = () => {
        this.setState({
            password: null,
            passwordConfirmation: null,
            isValidPassword: false,
        });
        this.props.onRequestClose && this.props.onRequestClose();
    };

    onChangePassword = e => {
        const value = e.target.value;
        this.setState(state => ({
            password: value,
            isValidPassword: isValidPassword(value) && value === state.passwordConfirmation
        }));
    };

    onChangePasswordConfirmation = e => {
        const value = e.target.value;
        this.setState(state => ({
            passwordConfirmation: value,
            isValidPassword: isValidPassword(value) && value === state.password
        }));
    }
}

const styles = {
    container: {
        flex: 1,
        padding: 10,
    },
    buttonsContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-end'
    },
    textField: {
        margin: 7
    },
    buttonCancel: {
        marginRight: 10
    }
};
